import type { BeeConceptId } from '../components/BeeSymbolConcept'

export interface BrandConcept {
  id: BeeConceptId
  name: string
  idea: string
  strengths: string[]
}

/** Client Review — Revision 01: bee symbol alternatives awaiting client approval. */
export const brandConcepts: BrandConcept[] = [
  {
    id: 'favo',
    name: 'A · Favo',
    idea: 'Corpo em hexágono, como uma célula da colmeia, com asas em forma de folha. Une a geometria da Minha Colmeia à natureza.',
    strengths: ['Abelha lida de imediato pelo corpo listrado', 'Conecta com Bee e Minha Colmeia', 'Silhueta compacta para ícone'],
  },
  {
    id: 'voo',
    name: 'B · Voo',
    idea: 'Abelha em perfil, em movimento, desenhada em linha com uma única asa orgânica. Expressa ritmo e evolução contínua.',
    strengths: ['Mais orgânico e leve', 'Sensação de movimento e progresso', 'Mais próximo do traço fino da marca'],
  },
  {
    id: 'selo',
    name: 'C · Selo da Colmeia',
    idea: 'Abelha vista de cima dentro de um selo hexagonal fino. Funciona como emblema e como ícone do app.',
    strengths: ['Mais legível em 16–32 px', 'Moldura ajuda no ícone do app', 'Leitura premium de selo'],
  },
]
